<template>
    <v-container>
        <creditor-objection-create-component v-if="user && user.profile == 1"></creditor-objection-create-component>
        <lawyer-objection-create-component v-else-if="user && user.profile == 4"></lawyer-objection-create-component>
    </v-container>
</template>

<script>
import CreditorObjectionCreateComponent from '@/components/creditor/CreditorObjectionCreateComponent.vue'
import LawyerObjectionCreateComponent from '@/components/lawyer/LawyerObjectionCreateComponent.vue'

export default {
    components: {
        'creditor-objection-create-component': CreditorObjectionCreateComponent,
        'lawyer-objection-create-component': LawyerObjectionCreateComponent,
    },
    data: () => ({
        user: null,
    }),

    created() {
        this.$ga.event({
            eventCategory: 'page',
            eventAction: 'action',
            eventLabel: 'click',
            eventValue: 'user-area'
        })
        this.user = this.$root.user;
    },
}
</script>

<style lang="scss"></style>
